export const GET_OTP_CODE_START = 'GET_OTP_CODE_START';

export const GET_OTP_CODE_SUCCESS = 'GET_OTP_CODE_SUCCESS';

export const GET_OTP_CODE_FAILURE = 'GET_OTP_CODE_FAILURE';
